import DataGrid, {Column} from "devextreme-react/data-grid";
import {useState} from "react";
import {apiGetNotificationBody} from "../api/get-notification-body";
import {CustomerNotification} from "../types/CustomerNotification";
import {Buffer} from 'buffer';
import {showErrorMessage} from "../../../../utils/messages";
import {LoadPopupPanel} from "../../../../components";

export default function CustomerNotificationGrid(props: { records: CustomerNotification[] }) {

	let [loading, setLoading] = useState(false);

	function viewNotification(id: number) {
		setLoading(true);
		apiGetNotificationBody(id).then((result) => {
			if (result.isSuccess) {
				const file = new Blob(
					[Buffer.from(result.data, "base64")],
					{ type: 'text/html' });

				const fileURL = URL.createObjectURL(file);
				window.open(fileURL);
			}
			else {
				showErrorMessage(result.errorMessage!);
			}
		})
			.catch((reason) => {
				showErrorMessage(reason);
			})
			.finally(() => { setLoading(false); });
	}

	return (
		<>
			<DataGrid
				className={'dx-card wide-card'}
				dataSource={props.records}
				allowColumnReordering={true}
				allowColumnResizing={true}
				showBorders={true}
				showColumnLines={true}
				columnAutoWidth={false}
				keyExpr={'notificationQueueID'}
			>
				<Column
					dataField={'notificationType'}
					caption={'Notification Type'}
					dataType="string"
				>
				</Column>
				<Column
					dataField={'sendAfter'}
					caption={'Sent on'}
					dataType="date"
					format="shortDate"
					width={100}
				/>
				<Column
					dataField={'to'}
					caption={'To'}
					dataType="string"
				/>
				<Column
					dataField={'subject'}
					caption={'Subject'}
					dataType="string"
				/>
				<Column
					dataField={'status'}
					caption={'Status'}
					dataType="string"
				/>
				<Column
					width={100}
					cellRender={(cell: any) => {
						if (cell.data.doneFlag)
							return <a
								onClick={() => viewNotification(cell.data.notificationQueueID)}>View</a>
						else
							return '';
					}}
				/>
			</DataGrid>
			<LoadPopupPanel visible={loading}></LoadPopupPanel>
		</>
	);
}
